import type { LoyaltyMessageDto } from "../../types/LoyaltyMessageDto";
import type { LoyaltyMessageEntity } from "../../types/LoyaltyMessageEntity";

export const LoyaltyMessageEntityToDto = ({ ...rest }: Readonly<LoyaltyMessageEntity>): LoyaltyMessageDto => {
    return { ...rest };
};
